// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"98":"schdNews","362":"brand","626":"gsdtNews","697":"news","702":"xpkxNews","836":"Antifake","893":"products","894":"services"}[chunkId] + "." + {"98":"a9ba6657","362":"94688f8e","626":"c2bcc918","697":"cd427082","702":"e02eca50","836":"338ee43f","893":"06bb550f","894":"8feac3f2"}[chunkId] + ".js";
};